import { render, staticRenderFns } from "./ProfessionForm.vue?vue&type=template&id=7f5ac51e&scoped=true"
import script from "./ProfessionForm.vue?vue&type=script&lang=js"
export * from "./ProfessionForm.vue?vue&type=script&lang=js"
import style0 from "./ProfessionForm.vue?vue&type=style&index=0&id=7f5ac51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5ac51e",
  null
  
)

export default component.exports